import {
	findMaskFieldBoundariesAtPosition,
	getValueAtIndex,
	setValueAtIndex,
	expandValueAtIndex,
} from './expandMaskUtils';

describe('findMaskFieldBoundariesAtPosition', () => {
	describe('on empty mask', function () {
		const mask = '__/__//____'; // note: second slash is here intentionally

		it('should return correct values for each field', function () {
			expect(findMaskFieldBoundariesAtPosition(mask, 0)).toEqual([0, 2]);
			expect(findMaskFieldBoundariesAtPosition(mask, 1)).toEqual([0, 2]);

			expect(findMaskFieldBoundariesAtPosition(mask, 3)).toEqual([3, 5]);
			expect(findMaskFieldBoundariesAtPosition(mask, 4)).toEqual([3, 5]);

			expect(findMaskFieldBoundariesAtPosition(mask, 7)).toEqual([7, 11]);
			expect(findMaskFieldBoundariesAtPosition(mask, 8)).toEqual([7, 11]);
			expect(findMaskFieldBoundariesAtPosition(mask, 9)).toEqual([7, 11]);
			expect(findMaskFieldBoundariesAtPosition(mask, 10)).toEqual([
				7, 11,
			]);
		});

		it('should return the same start and end values for separators', function () {
			expect(findMaskFieldBoundariesAtPosition(mask, 2)).toEqual([2, 2]);
			expect(findMaskFieldBoundariesAtPosition(mask, 5)).toEqual([5, 5]);
			expect(findMaskFieldBoundariesAtPosition(mask, 6)).toEqual([6, 6]);
		});
	});

	describe('on mask with values', function () {
		const mask = '05/20//19__'; // note: second slash is here intentionally

		it('should return correct values for each field', function () {
			expect(findMaskFieldBoundariesAtPosition(mask, 0)).toEqual([0, 2]);
			expect(findMaskFieldBoundariesAtPosition(mask, 1)).toEqual([0, 2]);

			expect(findMaskFieldBoundariesAtPosition(mask, 3)).toEqual([3, 5]);
			expect(findMaskFieldBoundariesAtPosition(mask, 4)).toEqual([3, 5]);

			expect(findMaskFieldBoundariesAtPosition(mask, 7)).toEqual([7, 11]);
			expect(findMaskFieldBoundariesAtPosition(mask, 8)).toEqual([7, 11]);
			expect(findMaskFieldBoundariesAtPosition(mask, 9)).toEqual([7, 11]);
			expect(findMaskFieldBoundariesAtPosition(mask, 10)).toEqual([
				7, 11,
			]);
		});

		it('should return the same start and end values for separators', function () {
			expect(findMaskFieldBoundariesAtPosition(mask, 2)).toEqual([2, 2]);
			expect(findMaskFieldBoundariesAtPosition(mask, 5)).toEqual([5, 5]);
			expect(findMaskFieldBoundariesAtPosition(mask, 6)).toEqual([6, 6]);
		});
	});
});

describe('getMaskValueAtIndexRange', function () {
	describe('for empty mask', function () {
		const mask = '__/__//____';

		it('should return value of particular mask field', function () {
			expect(getValueAtIndex(mask, 0)).toEqual('');
			expect(getValueAtIndex(mask, 1)).toEqual('');

			expect(getValueAtIndex(mask, 3)).toEqual('');
			expect(getValueAtIndex(mask, 4)).toEqual('');

			expect(getValueAtIndex(mask, 7)).toEqual('');
			expect(getValueAtIndex(mask, 8)).toEqual('');
			expect(getValueAtIndex(mask, 9)).toEqual('');
			expect(getValueAtIndex(mask, 10)).toEqual('');
		});

		it('should return null when index does not point mask field', function () {
			expect(getValueAtIndex(mask, 2)).toBeNull();
			expect(getValueAtIndex(mask, 5)).toBeNull();
			expect(getValueAtIndex(mask, 6)).toBeNull();
		});
	});

	describe('for filled in mask', function () {
		const mask = '10/22//2020';

		it('should return value of particular mask field', function () {
			expect(getValueAtIndex(mask, 0)).toEqual('10');
			expect(getValueAtIndex(mask, 1)).toEqual('10');

			expect(getValueAtIndex(mask, 3)).toEqual('22');
			expect(getValueAtIndex(mask, 4)).toEqual('22');

			expect(getValueAtIndex(mask, 7)).toEqual('2020');
			expect(getValueAtIndex(mask, 8)).toEqual('2020');
			expect(getValueAtIndex(mask, 9)).toEqual('2020');
			expect(getValueAtIndex(mask, 10)).toEqual('2020');
		});

		it('should return null when index does not point mask field', function () {
			expect(getValueAtIndex(mask, 2)).toBeNull();
			expect(getValueAtIndex(mask, 5)).toBeNull();
			expect(getValueAtIndex(mask, 6)).toBeNull();
		});
	});

	describe('for partially filled in mask', function () {
		const mask = '1_/2_//20__';

		it('should return value of particular mask field', function () {
			expect(getValueAtIndex(mask, 0)).toEqual('1');
			expect(getValueAtIndex(mask, 1)).toEqual('1');

			expect(getValueAtIndex(mask, 3)).toEqual('2');
			expect(getValueAtIndex(mask, 4)).toEqual('2');

			expect(getValueAtIndex(mask, 7)).toEqual('20');
			expect(getValueAtIndex(mask, 8)).toEqual('20');
			expect(getValueAtIndex(mask, 9)).toEqual('20');
			expect(getValueAtIndex(mask, 10)).toEqual('20');
		});

		it('should return null when index does not point mask field', function () {
			expect(getValueAtIndex(mask, 2)).toBeNull();
			expect(getValueAtIndex(mask, 5)).toBeNull();
			expect(getValueAtIndex(mask, 6)).toBeNull();
		});
	});
});

describe('setValueAtIndex', function () {
	describe('for empty mask', function () {
		const mask = '__/__//____';

		it('should return the same mask value when index does not point mask field', function () {
			expect(setValueAtIndex(mask, 2, 100)).toEqual(mask);
			expect(setValueAtIndex(mask, 5, 100)).toEqual(mask);
			expect(setValueAtIndex(mask, 6, 100)).toEqual(mask);
		});

		it('should set values when correct field index is passed', function () {
			expect(setValueAtIndex(mask, 0, 2)).toEqual('02/__//____');
			expect(setValueAtIndex(mask, 1, 2)).toEqual('02/__//____');

			expect(setValueAtIndex(mask, 3, 2)).toEqual('__/02//____');
			expect(setValueAtIndex(mask, 4, 2)).toEqual('__/02//____');

			expect(setValueAtIndex(mask, 7, 2)).toEqual('__/__//0002');
			expect(setValueAtIndex(mask, 8, 2)).toEqual('__/__//0002');
			expect(setValueAtIndex(mask, 9, 2)).toEqual('__/__//0002');
			expect(setValueAtIndex(mask, 10, 2)).toEqual('__/__//0002');
		});
	});

	describe('for filled in mask', function () {
		const mask = '05/20//2002';

		it('should return the same mask value when index does not point mask field', function () {
			expect(setValueAtIndex(mask, 2, 100)).toEqual(mask);
			expect(setValueAtIndex(mask, 5, 100)).toEqual(mask);
			expect(setValueAtIndex(mask, 6, 100)).toEqual(mask);
		});

		it('should set values when correct field index is passed', function () {
			expect(setValueAtIndex(mask, 0, 2)).toEqual('02/20//2002');
			expect(setValueAtIndex(mask, 1, 2)).toEqual('02/20//2002');

			expect(setValueAtIndex(mask, 3, 2)).toEqual('05/02//2002');
			expect(setValueAtIndex(mask, 4, 2)).toEqual('05/02//2002');

			expect(setValueAtIndex(mask, 7, 2)).toEqual('05/20//0002');
			expect(setValueAtIndex(mask, 8, 2)).toEqual('05/20//0002');
			expect(setValueAtIndex(mask, 9, 2)).toEqual('05/20//0002');
			expect(setValueAtIndex(mask, 10, 2)).toEqual('05/20//0002');
		});
	});

	describe('for partially filled in mask', function () {
		const mask = '5_/2_//20__';

		it('should return the same mask value when index does not point mask field', function () {
			expect(setValueAtIndex(mask, 2, 100)).toEqual(mask);
			expect(setValueAtIndex(mask, 5, 100)).toEqual(mask);
			expect(setValueAtIndex(mask, 6, 100)).toEqual(mask);
		});

		it('should set values when correct field index is passed', function () {
			expect(setValueAtIndex(mask, 0, 2)).toEqual('02/2_//20__');
			expect(setValueAtIndex(mask, 1, 2)).toEqual('02/2_//20__');

			expect(setValueAtIndex(mask, 3, 2)).toEqual('5_/02//20__');
			expect(setValueAtIndex(mask, 4, 2)).toEqual('5_/02//20__');

			expect(setValueAtIndex(mask, 7, 2)).toEqual('5_/2_//0002');
			expect(setValueAtIndex(mask, 8, 2)).toEqual('5_/2_//0002');
			expect(setValueAtIndex(mask, 9, 2)).toEqual('5_/2_//0002');
			expect(setValueAtIndex(mask, 10, 2)).toEqual('5_/2_//0002');
		});
	});
});

describe('expandValueAtIndex', function () {
	describe('for empty mask', function () {
		const mask = '__/__//____';

		it('should return the same (not filled) value', function () {
			expect(expandValueAtIndex(mask, 0)).toEqual(mask);
			expect(expandValueAtIndex(mask, 1)).toEqual(mask);

			expect(expandValueAtIndex(mask, 3)).toEqual(mask);
			expect(expandValueAtIndex(mask, 4)).toEqual(mask);

			expect(expandValueAtIndex(mask, 7)).toEqual(mask);
			expect(expandValueAtIndex(mask, 8)).toEqual(mask);
			expect(expandValueAtIndex(mask, 9)).toEqual(mask);
			expect(expandValueAtIndex(mask, 10)).toEqual(mask);
		});

		it('should return the same mask when index points to not mask field', function () {
			expect(expandValueAtIndex(mask, 2)).toEqual(mask);
			expect(expandValueAtIndex(mask, 5)).toEqual(mask);
			expect(expandValueAtIndex(mask, 6)).toEqual(mask);
		});
	});

	describe('for empty mask', function () {
		const mask = '1_/2_//30__';

		it('should return the same (not filled) value', function () {
			expect(expandValueAtIndex(mask, 0)).toEqual('01/2_//30__');
			expect(expandValueAtIndex(mask, 1)).toEqual('01/2_//30__');

			expect(expandValueAtIndex(mask, 3)).toEqual('1_/02//30__');
			expect(expandValueAtIndex(mask, 4)).toEqual('1_/02//30__');

			expect(expandValueAtIndex(mask, 7)).toEqual('1_/2_//0030');
			expect(expandValueAtIndex(mask, 8)).toEqual('1_/2_//0030');
			expect(expandValueAtIndex(mask, 9)).toEqual('1_/2_//0030');
			expect(expandValueAtIndex(mask, 10)).toEqual('1_/2_//0030');
		});

		it('should return the same mask when index points to not mask field', function () {
			expect(expandValueAtIndex(mask, 2)).toEqual(mask);
			expect(expandValueAtIndex(mask, 5)).toEqual(mask);
			expect(expandValueAtIndex(mask, 6)).toEqual(mask);
		});
	});

	describe('for filled in mask', function () {
		const mask = '02/20//1985';

		it('should return the same (not filled) value', function () {
			expect(expandValueAtIndex(mask, 0)).toEqual(mask);
			expect(expandValueAtIndex(mask, 1)).toEqual(mask);

			expect(expandValueAtIndex(mask, 3)).toEqual(mask);
			expect(expandValueAtIndex(mask, 4)).toEqual(mask);

			expect(expandValueAtIndex(mask, 7)).toEqual(mask);
			expect(expandValueAtIndex(mask, 8)).toEqual(mask);
			expect(expandValueAtIndex(mask, 9)).toEqual(mask);
			expect(expandValueAtIndex(mask, 10)).toEqual(mask);
		});

		it('should return the same mask when index points to not mask field', function () {
			expect(expandValueAtIndex(mask, 2)).toEqual(mask);
			expect(expandValueAtIndex(mask, 5)).toEqual(mask);
			expect(expandValueAtIndex(mask, 6)).toEqual(mask);
		});
	});
});
